var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBubbleOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C16.5439 4 20 7.45614 20 12C20 16.5439 16.5439 20 12 20C10.4035 20 9.03509 19.5789 7.75439 18.7895L4.38596 19.6316C4.36842 19.6316 4.36842 19.6316 4.36842 19.614L5.21053 16.2456C4.42105 14.9649 4 13.5965 4 12C4 7.45614 7.45614 4 12 4ZM12 2C6.47368 2 2 6.47368 2 12C2 13.614 2.40351 15.1754 3.07018 16.5263L2.4386 19.1579C2.08772 20.614 3.38596 21.9123 4.84211 21.5614L7.47368 20.9298C8.82456 21.5965 10.386 22 12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleOutlined);
export default __webpack_public_path__ + "static/media/chat_bubble_outlined.08484c9a.svg";
export { ForwardRef as ReactComponent };